import request from './request';

const SERVICE = '/webAppNotification/api/v1';

export const findAllPaged = (values) => {
  let endpoint = `${SERVICE}/findAllPaged`;

  return request.post(endpoint, values);
};

export const findAllPagedFiltered = (values) => {
  let endpoint = `${SERVICE}/findAllPagedFiltered`;

  return request.post(endpoint, values);
};

export const insert = async (notification) => {
  let endpoint = `${SERVICE}/insert`;

  return request.post(endpoint, notification);
};

export const update = async (notification) => {
  let endpoint = `${SERVICE}/update`;

  return request.put(endpoint, notification);
};

export const insertAndSave = async (values) => {
  let endpoint = `${SERVICE}/insertNotification`;

  return request.post(endpoint, values);
};

export const disableByIds = async (ids) => {
  let endpoint = `${SERVICE}/disableByIds`;

  return request.put(endpoint, ids);
};

export const send = async (id) => {
  let endpoint = `${SERVICE}/send/${id}`;

  return request.get(endpoint);
};

export const webAppNotificationPolling = async (values) => {
  let endpoint = `${SERVICE}/webAppNotificationPolling/`;

  return request.post(endpoint, values);
};

export const findAllPagedCustom = (values) => {
  let endpoint = `${SERVICE}/findAllPagedCustom`;

  return request.post(endpoint, values);
};

export const setReadNotification = (values) => {
  let endpoint = `${SERVICE}/setReadNotification`;

  return request.post(endpoint, values);
};
